import React, { useState } from 'react'
import { Bell } from 'lucide-react'
import { AnimatePresence } from 'framer-motion'
import { useAdminNotifications } from '../../../hooks/useAdminNotifications'
import AdminNotificationDropdown from './AdminNotificationDropdown'

const AdminNotificationBell: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)

  const {
    notifications,
    unreadCount,
    isLoading,
    markAsRead,
    markAllAsRead,
  } = useAdminNotifications({ pageSize: 20 })

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 hover:bg-cream-100 dark:hover:bg-ink-900/40 rounded-caderno-sm relative transition-colors"
      >
        <Bell className="w-5 h-5 text-ink-500 dark:text-ink-400" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-blood-500 text-white text-xs rounded-full flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      <AnimatePresence>
        {isOpen && (
          <AdminNotificationDropdown
            notifications={notifications}
            unreadCount={unreadCount}
            isLoading={isLoading}
            onMarkAsRead={markAsRead}
            onMarkAllAsRead={markAllAsRead}
            onClose={() => setIsOpen(false)}
          />
        )}
      </AnimatePresence>
    </div>
  )
}

export default AdminNotificationBell
